import dayjs from 'dayjs';
import { GetServerSideProps } from 'next';
import { useRouter } from 'next/router';
import { useMount } from 'react-use';

import { isTourist } from '../utils';

import { getTokenByRefreshTokenV2 } from '@/api/login';
import CacheStorage from '@/utils/cacheStorage';
import {
  LAST_REFRESH_TIME,
  NEED_REFRESH_TOKEN_DAY,
  REFRESH_TOKEN,
  TOKEN,
} from '@/utils/constants';
import { goWebSite } from '@/utils/goWebSite';
import {
  removeRealToken,
  removeTokenInfo,
  setRealToken,
  setTokenInfo,
} from '@/utils/helpers';
import useQuery from '@/utils/hooks/useQuery';

export const getServerSideProps: GetServerSideProps = async ({
  req,
  query,
}) => {
  const token = query?.token || req.headers?.token;
  return {
    props: {
      tokenApp: token || '',
    },
  };
};

const useAuth = (props?: { tokenApp: string }) => {
  const { tokenApp } = props || {};
  const { token: tokenUrl, ...restQuery } = useQuery() as Record<
    string,
    string
  >;
  const router = useRouter();
  const tourist = isTourist();
  useMount(() => {
    if (tourist) {
      // 临时存储 sign，手机号校验后清除
      removeRealToken();
    }
    if (tokenUrl) {
      CacheStorage.setItem(TOKEN, tokenUrl);
      const { pathname } = router;
      router.replace({ pathname, query: restQuery }, undefined, {
        shallow: true,
      });
    }
    if (tokenApp) {
      CacheStorage.setItem(TOKEN, tokenApp);
    }
    const token = CacheStorage.getItem<string>(TOKEN);
    const lastRefreshTime = CacheStorage.getItem<string>(LAST_REFRESH_TIME);

    if (!tourist && !token) {
      if (
        window.location.href.includes(':3000/') ||
        window.location.href.includes('-3000.')
      ) {
        setRealToken(
          'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI2NmIwMGY1My0xNTM4LTRjMGUtODk3MC1mMjkzOWJlNDllMjQiLCJhdXRob3JpdGllcyI6WyJTVFVERU5UIl0sIm5hbWUiOiJ3a1dDdnR1NSIsImV4cCI6MTc1ODg2NjI2NDQ1NCwicGhvbmUiOiIrODIgMTc1NjI3NDIzOCIsImFjY291bnRTdGF0dXMiOiJOT1JNQUwiLCJkZXBhcnRtZW50cyI6W10sImRhdGEiOnsic3R1ZGVudElkIjoiMTJjZjQzZjAtNDYzZC00OWE0LWI0MTUtYmRiZTFiMjk5NzMwIiwiY29kZSI6IkRTQTIxOCIsImFzc29jaWF0ZWRXZUNoYXQiOmZhbHNlLCJzdHVkZW50TGV2ZWwiOjMwLCJhc3NvY2lhdGVkU3R1ZGVudHMiOnRydWUsInBsYXRmb3JtIjoid2ViIiwic3RhdHVzIjoi5pyq5LuY6LS5In19.fjQThDLA9K63xIpKV1bw1kgLuc0KYf5ul8be1KIOP5I',
        );
        return;
      }
      // 需要强制登录 获取学员信息
      goWebSite();
    } else if (
      token &&
      (!lastRefreshTime ||
        dayjs().add(NEED_REFRESH_TOKEN_DAY, 'day').unix() > +lastRefreshTime)
    ) {
      getTokenByRefreshTokenV2({
        refreshToken: CacheStorage.getItem(REFRESH_TOKEN),
      })
        .then(res => {
          const { content } = res || {};
          const { token: newToken, refreshToken: newRefreshToken } =
            content || {};
          if (newToken && newRefreshToken) {
            setTokenInfo(newToken, newRefreshToken);
          } else {
            removeTokenInfo(null, true);
          }
        })
        .catch(e => {
          console.log(e, 'useAuth catch');
          removeTokenInfo(null, true);
        });
    }
  });
};

export default useAuth;
